<template>
  <div id="ArticleTitle">
    <div id="Title">{{title}}</div>
    <img class="brief_up" src="../assets/brief_up.png">
    <div id="Brief">{{brief}}</div>
    <img class="brief_down" src="../assets/brief_down.png">
    <div id="SecondTitle">{{secondTitle}}</div>
    <div id="Date">{{date}}</div>
  </div>
</template>

<script>
let articles=[];
articles[0]=require("../store/articlesStore_1");
articles[1]=require("../store/articlesStore_2");
export default {
  name: "ArticleTitle",
  computed:{
    title(){
      return articles[this.$route.params.issue-1].default.state.articles[this.$route.params.id-1].title
    },
    secondTitle(){
      return articles[this.$route.params.issue-1].default.state.articles[this.$route.params.id-1].second_title
    },
    brief(){
      return articles[this.$route.params.issue-1].default.state.articles[this.$route.params.id-1].brief
    },
    date(){
      return articles[this.$route.params.issue-1].default.state.articles[this.$route.params.id-1].date
    }
  }
}
</script>

<style lang="less" scoped>
#ArticleTitle {
  width: 100%;

  #Title{
    width: 100%;
    line-height:.71rem;
    font-size:.55rem;
    color: black;
    font-weight: bolder;
  }

  .brief_up{
    margin-top:.27rem;
    width: .47rem;
    float: left;
  }
  .brief_down{
    width: .46rem;
    float: right;
  }
  #Brief{
    color: #666666;
    width: 100%;
    padding-left:.34rem;
    padding-right:.34rem;
    //padding-top:.34rem;
    padding-bottom:.15rem;
    line-height:.77rem;
    font-size:.4rem;
    margin-top:.27rem;
    //border-bottom:.01rem solid #333333
    //border-left:.04rem solid #333333
  }

  #SecondTitle{
    color: #666666;
    width: 100%;
    margin-top:.35rem;
    line-height:.45rem;
    font-size:.35rem;
  }

  #Date{
    color: #b3b3b3;
    width: 100%;
    margin-top:.1rem;
    line-height:.5rem;
    font-size:.3rem;
    padding-bottom:.15rem;
    //border-bottom:.01rem solid #333333
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleTitle.vue